module.exports = __webpack_public_path__ + "img/yty-change.548b3efd.svg";